/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="95.58" height="70.67" viewBox="0 0 95.58 70.67" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="ba716b45-e4e2-4e4d-aa9d-20c595f76642" x="0" y="0" width="95.58" height="70.67" maskUnits="userSpaceOnUse">
      <g transform="translate(-29 -42.5)">
        <polygon points="29 113.17 124.58 113.17 124.58 42.5 29 42.5 29 113.17" fill="#fff" fillRule="evenodd"/>
      </g>
    </mask>
  </defs>
  <g>
      <path d="M85.33,71.4a1.25,1.25,0,0,1,1.24,1.12V98.18a1.26,1.26,0,0,1-1.12,1.25H57.27A1.26,1.26,0,0,1,56,98.31v-25a1.25,1.25,0,0,1,2.49-.13V96.93H84.08V72.65a1.24,1.24,0,0,1,1.12-1.24Z" transform="translate(-29 -42.5)" fill="#ffb81c"/>
      <path d="M98.59,86.83A1.26,1.26,0,0,1,99.84,88V98.18a1.26,1.26,0,0,1-1.12,1.25H70.53a1.25,1.25,0,0,1-.13-2.49H97.34V88.08a1.25,1.25,0,0,1,1.12-1.24Z" transform="translate(-29 -42.5)" fill="#ffb81c"/>
      <path d="M70.73,64.1a1.24,1.24,0,0,1,1-.07l.14.06,21.2,10.38a1.25,1.25,0,0,1-1,2.3l-.12,0L71.31,66.61l-19.9,10.1a1.25,1.25,0,0,1-1.61-.43l-.07-.12a1.24,1.24,0,0,1,.43-1.61l.12-.07Z" transform="translate(-29 -42.5)" fill="#ffb81c"/>
      <path d="M84.21,80.23a1.24,1.24,0,0,1,1.55-.62l.12,0,17.36,8.49a1.25,1.25,0,0,1-1,2.3l-.12,0L84.78,81.9A1.24,1.24,0,0,1,84.21,80.23Z" transform="translate(-29 -42.5)" fill="#ffb81c"/>
      <g>
        <path d="M115.74,42.5a8.84,8.84,0,0,1,8.84,8.58v53.25a8.84,8.84,0,0,1-8.58,8.84H37.84A8.84,8.84,0,0,1,29,104.59V51.34a8.85,8.85,0,0,1,11.42-8.46A1.26,1.26,0,0,1,41.3,44V97.07a1.26,1.26,0,0,1-1.62,1.2A6,6,0,0,0,37.84,98a6.34,6.34,0,0,0-.23,12.68h78.13a6.34,6.34,0,0,0,0-12.68,6.1,6.1,0,0,0-1.85.28,1.26,1.26,0,0,1-1.61-1.08V44.08a1.26,1.26,0,0,1,.88-1.2A9,9,0,0,1,115.74,42.5ZM37.84,45a6.35,6.35,0,0,0-6.34,6.11V98.17l.09-.09a8.77,8.77,0,0,1,6-2.58h.26q.38,0,.75,0l.22,0V45.07h0a6.2,6.2,0,0,0-.62-.06Zm77.9,0q-.31,0-.63,0l-.33,0V95.55l.21,0,.38,0h.37A8.81,8.81,0,0,1,122,98.08l.09.09V51.34A6.34,6.34,0,0,0,116,45Z" transform="translate(-29 -42.5)" fill="#0e497b"/>
        <polygon points="84.53 9.18 84.53 11.68 11.06 11.68 11.06 9.18 84.53 9.18" fill="#0e497b"/>
        <g mask="url(#ba716b45-e4e2-4e4d-aa9d-20c595f76642)">
          <path d="M77.64,77.57H65V90.26H77.64Zm-2.5,2.5v7.69H67.45V80.07Z" transform="translate(-29 -42.5)" fill="#0e497b"/>
        </g>
      </g>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'BlueprintWithHouseIcon';

export default Icon;
